var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"el-icon-back",on:{"click":_vm.goBack}})
}
var staticRenderFns = []

export { render, staticRenderFns }